import { UsersDirectoryFormData } from 'mk2/apps/users/components/UsersDirectoryForm';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

export const USERS_DIRECTORY_SEARCH_TRIGGER = 'USERS_DIRECTORY_SEARCH_TRIGGER';
export interface UsersDirectorySearchTriggerAction {
    readonly type: typeof USERS_DIRECTORY_SEARCH_TRIGGER;
    readonly searchFd: UsersDirectoryFormData;
}
export const USERS_DIRECTORY_SEARCH_REQUEST = 'USERS_DIRECTORY_SEARCH_REQUEST';
export interface UsersDirectorySearchRequestAction extends APIRequestAction {
    readonly type: typeof USERS_DIRECTORY_SEARCH_REQUEST;
    readonly searchFd: UsersDirectoryFormData;
}
export interface UsersDirectorySearchNormalizedResponse extends NormalizedResponse {
    readonly result: { usersStats: number[]; };
}
export const USERS_DIRECTORY_SEARCH_SUCCESS = 'USERS_DIRECTORY_SEARCH_SUCCESS';
export interface UsersDirectorySearchSuccessAction extends APISuccessAction<UsersDirectorySearchNormalizedResponse> {
    readonly type: typeof USERS_DIRECTORY_SEARCH_SUCCESS;
    readonly hasMore: boolean;
    readonly searchFd: UsersDirectoryFormData;
}
export const USERS_DIRECTORY_SEARCH_FAILURE = 'USERS_DIRECTORY_SEARCH_FAILURE';
export interface UsersDirectorySearchFailureAction extends APIFailureAction {
    readonly type: typeof USERS_DIRECTORY_SEARCH_FAILURE;
    readonly searchFd: UsersDirectoryFormData;
}

export const usersDirectorySearchTrigger =  (searchFd: UsersDirectoryFormData): UsersDirectorySearchTriggerAction => ({
    type: USERS_DIRECTORY_SEARCH_TRIGGER, searchFd,
});
export const usersDirectorySearchAPI = {
    request: (searchFd: UsersDirectoryFormData): UsersDirectorySearchRequestAction => ({
        type: USERS_DIRECTORY_SEARCH_REQUEST, searchFd,
    }),
    success: (searchFd: UsersDirectoryFormData, hasMore: boolean, response: UsersDirectorySearchNormalizedResponse): UsersDirectorySearchSuccessAction => ({
        type: USERS_DIRECTORY_SEARCH_SUCCESS, searchFd, hasMore, response,
    }),
    failure: (searchFd: UsersDirectoryFormData, error: any): UsersDirectorySearchFailureAction => ({
        type: USERS_DIRECTORY_SEARCH_FAILURE, searchFd, error,
    }),
};
